import { Cookie } from './cookies';
import { getTokenKey } from './getTokenKey';

export const getUnioneToken = (): Promise<string | null> => new Promise((resolve, reject) => {
  try {
    const tokenKey = getTokenKey();
    const cookie = Cookie.get(tokenKey);
    const token = cookie && cookie !== 'null' ? cookie : null;
    resolve(token);
  } catch (error) {
    reject(error);
  }
});
